import React, { useImperativeHandle, forwardRef, useState } from "react";
import propsTypes from "prop-types";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";

const useStyles = makeStyles({
  list: {
    width: 250,
  },
  fullList: {
    width: "auto",
    maxHeight: "300px",
  },
});

const Modal = forwardRef((props, ref) => {
  const { anchor, className, listClassName, onKeyDown, onClose, children } =
    props;

  const classes = useStyles();

  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    changeStatus() {
      toggleDrawer();
    },
  }));

  const toggleDrawer = () => {
    setShowModal(!showModal);
  };

  const list = () => (
    <div
      className={`${clsx(classes.list, {
        [classes.fullList]: anchor,
      })} ${listClassName}`}
      role="presentation"
      {...(onKeyDown && { onKeyDown: toggleDrawer })}
    >
      {children}
    </div>
  );

  return (
    <Drawer
      className={className}
      anchor={anchor}
      open={showModal}
      {...(onClose && { onClose: toggleDrawer })}
    >
      {list()}
    </Drawer>
  );
});

Modal.propsTypes = {
  className: propsTypes.string,
  listClassName: propsTypes.string,
  anchor: propsTypes.string,
  onKeyDown: propsTypes.bool,
  onClose: propsTypes.bool,
  children: propsTypes.elementType,
};

Modal.defaultProps = {
  onKeyDown: false,
  onClose: true,
  anchor: "bottom",
};

export default Modal;
